import { API_BASE } from "../utils/api";

export default function RegisterStepUser({
    form,
    errors,
    setForm,
    setErrors,
    onBack,
    onFinish,
    submitLabel = "Finalizar registro", // 👈 TEXTO CONFIGURABLE
    isEdit = false, // 👈 NUEVO
    shipTos = [], // 👈 sedes del cliente, para elegir a que sede queda el usuario
}) {
    const hasUserError = Boolean(errors.username);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({ ...prev, [name]: undefined }));
    };

    const checkUsernameExists = async (username) => {
        if (!username) return;

        try {
            const res = await fetch(
                `${API_BASE}/customers-ultra/api/ws/exists_user?user=${encodeURIComponent(username)}`
            );

            if (!res.ok) return;

            const exists = await res.json();

            if (exists) {
                setErrors((prev) => ({
                    ...prev,
                    username: "Este usuario ya existe",
                }));
            }
        } catch (err) {
            console.error("Error validando usuario", err);
        }
    };
    const generateSuggestedUsername = async () => {
        // Solo procedemos si tenemos ambos datos
        if (!form.userFirstName || !form.userLastName) return;

        try {
            const res = await fetch(
                `${API_BASE}/customers-ultra/api/ws/fun_generate_user?first_name=${encodeURIComponent(form.userFirstName)}&last_name=${encodeURIComponent(form.userLastName)}`
            );

            if (!res.ok) return;

            const suggestedUsername = await res.text(); // El servicio retorna un String puro

            if (suggestedUsername) {
                // 1. Actualizamos el campo username en el form
                setForm((prev) => ({
                    ...prev,
                    username: suggestedUsername,
                }));

                // 2. Limpiamos errores previos del username
                setErrors((prev) => ({ ...prev, username: undefined }));

                // 3. Opcional: Validar de inmediato si ese usuario sugerido ya existe
                //      checkUsernameExists(suggestedUsername);
            }
        } catch (err) {
            console.error("Error generando sugerencia de usuario", err);
        }
    };

    return (
        <>
            <h1 className="text-xl font-semibold text-gray-800 -mt-5">
                Datos del usuario
            </h1>

            <form autoComplete="off" className="space-y-6 mt-4">

                {/* ================= DATOS PERSONALES ================= */}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    <Field label="Nombres *">
                        <input
                            name="userFirstName"
                            value={form.userFirstName || ""}
                            onChange={handleChange}
                            className={`w-full border px-3 py-2 text-sm
                        ${errors.userFirstName ? "border-red-500" : "border-gray-300"}
                         focus:outline-none focus:ring-0 focus:border-gray-500`}
                        />
                        {errors.userFirstName && (
                            <p className="mt-1 text-xs text-red-600">
                                {errors.userFirstName}
                            </p>
                        )}
                    </Field>

                    <Field label="Apellidos *">
                        <input
                            name="userLastName"
                            value={form.userLastName || ""}
                            onChange={handleChange}
                            onBlur={generateSuggestedUsername}
                            className={`w-full border px-3 py-2 text-sm
                          ${errors.userLastName ? "border-red-500" : "border-gray-300"}
                            focus:outline-none focus:ring-0 focus:border-gray-500`}
                        />
                        {errors.userLastName && (
                            <p className="mt-1 text-xs text-red-600">
                                {errors.userLastName}
                            </p>
                        )}
                    </Field>

                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-blue-800 font-medium">
                    <Field label="Su usuario">
                        <input
                            name="username"
                            value={form.username || ""}
                            onChange={handleChange}
                            autoComplete="new-username"
                            disabled={true} // Siempre deshabilitado porque lo genera el sistema
                            onBlur={(e) => checkUsernameExists(e.target.value)}
                            className={`w-full border px-3 py-2 text-sm transition-colors
                             ${errors.username
                                    ? "border-red-500 bg-red-50"
                                    : "border-blue-200 bg-blue-50/50 text-blue-800 font-medium"
                                }
                              cursor-not-allowed focus:outline-none`}
                        />
                        {errors.username && (
                            <p className="mt-1 text-xs text-red-600">{errors.username}</p>
                        )}
                    </Field>

                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    <Field label="Contraseña *">
                        <input
                            type="password"
                            name="password"
                            value={form.password || ""}
                            onChange={handleChange}
                            autoComplete="new-password"
                            className={`w-full border px-3 py-2 text-sm
                            ${errors.password ? "border-red-500" : "border-gray-300"}
                               focus:outline-none focus:ring-0 focus:border-gray-500`}
                        />
                        {errors.password && (
                            <p className="mt-1 text-xs text-red-600">{errors.password}</p>
                        )}
                    </Field>

                    <Field label="Confirmar contraseña *">
                        <input
                            type="password"
                            name="confirmPassword"
                            value={form.confirmPassword || ""}
                            onChange={handleChange}
                            autoComplete="new-password"
                            className={`w-full border px-3 py-2 text-sm
                            ${errors.confirmPassword ? "border-red-500" : "border-gray-300"}
                               focus:outline-none focus:ring-0 focus:border-gray-500`}
                        />
                        {errors.confirmPassword && (
                            <p className="mt-1 text-xs text-red-600">
                                {errors.confirmPassword}
                            </p>
                        )}
                    </Field>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <Field label="Email *">
                        <input
                            type="email"
                            name="userEmail"
                            value={form.userEmail || ""}
                            onChange={handleChange}
                            autoComplete="new-email"
                            className={`w-full border px-3 py-2 text-sm
                            ${errors.userEmail ? "border-red-500" : "border-gray-300"}
                               focus:outline-none focus:ring-0 focus:border-gray-500`}
                        />
                        {errors.userEmail && (
                            <p className="mt-1 text-xs text-red-600">{errors.userEmail}</p>
                        )}
                    </Field>
                    <Field label="Celular *">
                        <input
                            name="userPhone"
                            value={form.userPhone || ""}
                            onChange={handleChange}
                            className={`w-full border px-3 py-2 text-sm
                            ${errors.userPhone ? "border-red-500" : "border-gray-300"}
                               focus:outline-none focus:ring-0 focus:border-gray-500`}
                        />
                        {errors.userPhone && (
                            <p className="mt-1 text-xs text-red-600">{errors.userPhone}</p>
                        )}
                    </Field>

                </div>

                {/* 👇 SOLO SI EL CLIENTE TIENE MAS DE UNA SEDE. No es obligatorio elegir:
                     si se deja en "Matriz", el usuario queda con idShipTo null. */}
                {shipTos.length > 0 && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <Field label="Sucursal">
                            <select
                                name="idShipTo"
                                value={form.idShipTo ?? ""}
                                onChange={handleChange}
                                className="w-full border border-gray-300 px-3 py-2 text-sm bg-white
                                   focus:outline-none focus:ring-0 focus:border-gray-500"
                            >
                                <option value="">Matriz</option>
                                {shipTos.map((s) => (
                                    <option key={s.idShipTo} value={s.idShipTo}>
                                        {s.nameShipTo}
                                    </option>
                                ))}
                            </select>
                        </Field>
                    </div>
                )}

                {/* 👇 SOLO EN EDICIÓN */}
                {isEdit && (
                    <div className="flex items-center gap-3 pt-2">
                        <input
                            type="checkbox"
                            id="discontinued"
                            checked={!!form.discontinued}
                            onChange={(e) =>
                                setForm({ ...form, discontinued: e.target.checked })
                            }
                            className="h-4 w-4"
                        />
                        <label htmlFor="discontinued" className="text-sm font-medium text-gray-700">
                            Suspender usuario
                        </label>
                    </div>
                )}

            </form>

            {/* ================= BOTONES ================= */}
            <div className="flex justify-between pt-8">
                <button
                    type="button"
                    onClick={onBack}
                    className="border border-gray-300 px-6 py-2 text-sm text-gray-700"
                >
                    Atrás
                </button>

                <button
                    type="button"
                    disabled={hasUserError}
                    onClick={onFinish}
                    className={`text-white text-sm font-semibold px-8 py-2
                        ${hasUserError
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-brand-primary hover:brightness-90"}`}
                >
                    {submitLabel}
                </button>
            </div>
        </>
    );
}

function Field({ label, children }) {
    return (
        <div className="w-full">
            <label className="block text-sm text-gray-700 mb-1">
                {label}
            </label>
            {children}
        </div>
    );
}
